// @flow
import React from 'react';
import { AnyAction } from 'redux';
import { useSelector } from 'react-redux';
import { sanitizeRouteParams } from 'metaup/routing/routingUtils';
import type { Routes } from 'metaup/routing/routingUtils';
import DownloadPageView from './views/DownloadPageView';

type DownloadState = {};

const initialState: DownloadState = {};

const ACTION_SET_STATE = 'download/download/ACTION_SET_STATE';

function setState(stateDelta: Object) {
  return {
    type: ACTION_SET_STATE,
    stateDelta,
  };
}

export function downloadReducer(
  state: DownloadState = initialState,
  action: AnyAction
) {
  switch (action.type) {
    case ACTION_SET_STATE:
      return {
        ...state,
        ...action.stateDelta,
      };
    default:
      return state;
  }
}

function DownloadPage() {
  const {}: DownloadState = useSelector(({ download }) => download.download);

  return (
    <DownloadPageView />
  );
}

export function downloadPageRoutes(): Routes {
  return [
    {
      title: 'Загрузка',
      path: '/',
      isEnabled: ({ isUser }) => isUser,
      nav: { showNews: true },
      render: params => (
        <DownloadPage
          {...sanitizeRouteParams(params, {
          })}
        />
      ),
    },
  ];
}
